// extracted by mini-css-extract-plugin
export default {"chartWrapper":"C9bpWMbJ","chartReveal":"dK8qUaXC","chartTitle":"l1gwF0kk","chartContainer":"xHTB6gS_"};